// extracted by mini-css-extract-plugin
module.exports = {"root":"Grid_root__xSU_B","row":"Grid_row__1rWaL","large":"Grid_large__2_Ser"};